import { render } from "./ComponentChart.vue?vue&type=template&id=0ce287de&ts=true"
import script from "./ComponentChart.vue?vue&type=script&lang=ts"
export * from "./ComponentChart.vue?vue&type=script&lang=ts"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__